<template>
    <div class="container">
        <div class="row text-center mt-3">
            <div class="no-posts-section">
                <img  src="../../../public/assets/images/noposts.png" alt="ZuluTrade 1">
                <p class="mt20">No Data found</p>
            </div>
        </div>
    </div>
</template>